import React from 'react';
import { ChainIcon } from 'src/components/Icons';
import * as Ui from './styles';

export default function CombinedQuestions({ 
  title, 
  combinatedQuestions,
  onSelect,
}) {

  const handleOnSelectCombination = () => {
    if (onSelect) onSelect();
  };

  return (
    <Ui.Container>
      <Ui.MatchMainQuestions>
        <Ui.CombineTitle>{title}</Ui.CombineTitle>
        <Ui.ChainWrapper>
          <ChainIcon /> 
          <Ui.MatchedQuestions onClick={handleOnSelectCombination}>
            {combinatedQuestions} combinações
          </Ui.MatchedQuestions>
        </Ui.ChainWrapper>
      </Ui.MatchMainQuestions>
    </Ui.Container>
  );
}
